"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const Notifications_1 = __importDefault(require("@mui/icons-material/Notifications"));
const Switch_1 = __importDefault(require("@mui/material/Switch"));
const material_1 = require("@mui/material");
const helpers_1 = require("../../../common/helpers/helpers");
const modalEnums_1 = __importDefault(require("../../../common/modalEnums"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const pushService_1 = __importDefault(require("../../../common/services/pushService"));
const PermissionsOutsideWrapper = styled_components_1.default.div ``;
const PermissionsInsideWrapper = styled_components_1.default.div `
  border-radius: 10px;
  padding: 8px;
  background-color: ${props => (props.theme.palette.mainAppColor.light)};
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 780px) {
    flex-direction: column;
    align-items: flex-end;
    gap: 5px;
  }

  .MuiSwitch-switchBase.Mui-checked {
    color: ${(props) => props.theme.palette.mainAppColor.dark};
  }

  .Mui-checked + .MuiSwitch-track {
    background-color: ${(props) => props.theme.palette.mainAppColor.main};
    opacity: 0.38;
  }
`;
const PermissionAction = styled_components_1.default.div ``;
const IconAndText = styled_components_1.default.div `
    display: flex;
    align-items: center;
    align-self: flex-start;
    gap: 10px;
    margin: auto 0;
    text-align: left;

    .permisisons-text{
        margin: 0;
    }

    @media (max-width: 780px) {
       display: inline ;

       .permisisons-text {
        display: inline;
       }

       svg {
        margin-right: 5px;
        vertical-align: top;
       }
    }
`;
const NotificationPermisisons = ({ appData, currentLocale, userData, updateStore, pushNotificationsEnabled, onDeny, ignoreLocalStorage, }) => {
    // toggle( default ), dismiss, details
    const [actionButton, setActionButton] = (0, react_1.useState)("toggle");
    const [showPermissions, setShowPermissions] = (0, react_1.useState)(localStorage.getItem("permissionsWereInteractedWith") !== "true");
    const [displayText, setDisplayText] = (0, react_1.useState)(i18n_js_1.default.t("permission_banner_notifications"));
    const [showAsToggledOn, setShowAsToggledOn] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (ignoreLocalStorage) {
            setShowPermissions(true);
        }
        if (helpers_1.Helpers.isMobile.iOS() && !helpers_1.Helpers.isPWA()) {
            setActionButton("details");
            return;
        }
        if ("Notification" in window && Notification.permission === "denied") {
            setDisplayText(i18n_js_1.default.t("To_enable_notifications_go_to_Notification_Settings"));
            setActionButton("dismiss");
        }
    }, []);
    if (!("Notification" in window)) {
        // is safari
        if (helpers_1.Helpers.isMobile.iOS() && !helpers_1.Helpers.isPWA()) {
            // render  component as normal
        }
        else {
            return null;
        }
    }
    if (pushNotificationsEnabled || !showPermissions) {
        return null;
    }
    const handleChange = (evt) => {
        if (evt.target.checked) {
            const setToggleTo = (value) => {
                if (onDeny && value === false) {
                    onDeny();
                }
                if (value === true) {
                    setShowAsToggledOn(true);
                }
                setTimeout(() => {
                    updateStore("pushNotificationsEnabled", value);
                    setShowPermissions(false);
                    localStorage.setItem("permissionsWereInteractedWith", "true");
                }, 1000);
            };
            pushService_1.default.requestNotificationPermission(appData.vapidPublicKey, userData.token, currentLocale, setToggleTo);
        }
        if (!evt.target.checked) {
            updateStore("pushNotificationsEnabled", false);
            setShowAsToggledOn(false);
            pushService_1.default.disablePushService(userData.token, currentLocale);
        }
    };
    const renderSwitch = (param) => {
        switch (param) {
            case "details":
                return (react_1.default.createElement(material_1.Button, { onClick: () => {
                        helpers_1.Helpers.openModal(modalEnums_1.default.NOTIFICATION_INSTRUCTIONS);
                    }, color: "mainAppColor" }, i18n_js_1.default.t("details")));
            case "dismiss":
                return (react_1.default.createElement(material_1.Button, { onClick: () => {
                        setShowPermissions(false);
                        localStorage.setItem("permissionsWereInteractedWith", "true");
                    }, color: "mainAppColor" }, i18n_js_1.default.t("noti_center_dismiss_switch_hotel")));
            default:
                return (react_1.default.createElement(Switch_1.default, { checked: pushNotificationsEnabled || showAsToggledOn, onChange: handleChange, inputProps: { "aria-label": "controlled" }, disabled: "Notification" in window && Notification.permission === "denied" }));
        }
    };
    return (react_1.default.createElement(PermissionsOutsideWrapper, { className: "permission-controls" },
        react_1.default.createElement(PermissionsInsideWrapper, null,
            react_1.default.createElement(IconAndText, null,
                react_1.default.createElement(Notifications_1.default, null),
                react_1.default.createElement("p", { className: "permisisons-text" }, displayText)),
            react_1.default.createElement(PermissionAction, null, renderSwitch(actionButton)))));
};
const mapStoreToProps = (store) => ({
    userData: store.getValue("userData"),
    currentLocale: store.getValue("currentLocale"),
    appData: store.getValue("appData"),
    pushNotificationsEnabled: store.getValue("pushNotificationsEnabled"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(NotificationPermisisons);
